// extracted by mini-css-extract-plugin
export var linkText = "_oy-0";